import { IFailedManualStepOrderEditItem } from "../../Interfaces/manualInterfaces";
import { addSeperatorToInput } from "../../helper";

interface IProps {
  rows: IFailedManualStepOrderEditItem[] | null | undefined;
}

const EditFailedOrdersTable = ({ rows }: IProps) => {
  if (!rows?.length) return null;

  return (
    <table className="w-full max-w-[860px] border-collapse rounded border border-red-300 bg-red-50 text-xs text-red-800">
      <thead>
        <tr>
          <th className="border border-red-300 px-3 py-2 text-right">#</th>
          <th className="border border-red-300 px-3 py-2 text-right">نام</th>
          <th className="border border-red-300 px-3 py-2 text-right">
            حجم اولیه
          </th>
          <th className="border border-red-300 px-3 py-2 text-right">
            حجم انجام‌شده
          </th>
          <th className="border border-red-300 px-3 py-2 text-right">
            حجم درخواستی
          </th>
          <th className="border border-red-300 px-3 py-2 text-right">علت</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <tr key={`${row.manualStepOrderId}-${index}`}>
            <td className="border border-red-200 px-3 py-2">{index + 1}</td>
            <td className="border border-red-200 px-3 py-2">
              {row.name || "-"}
            </td>
            <td className="border border-red-200 px-3 py-2 ltr">
              {addSeperatorToInput(row.initialVolume, "price")}
            </td>
            <td className="border border-red-200 px-3 py-2 ltr">
              {addSeperatorToInput(row.doneVolume, "price")}
            </td>
            <td className="border border-red-200 px-3 py-2 ltr">
              {addSeperatorToInput(row.requestedVolume, "price")}
            </td>
            <td className="border border-red-200 px-3 py-2">{row.reason}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default EditFailedOrdersTable;
